import React, { useContext, useMemo, useState } from "react";
import { Box, Grid, Switch, Typography } from "@mui/material";
import CustomBreadcrumbs from "../../../../components/BreadcrumbsComponent/CustomBreadcrumbs";
import { PreferencesContext } from "../../../../PreferenceContext";
import {
  CreateConfiguration,
  UpdateConfiguration,
} from "../../../../services/SystemConfigurationService";
import { AlertType } from "../../../../services/models/AlertType";

const BillingConfiguration = () => {
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const billingConfig = useMemo(() => {
    return userContext?.systemConfigurationColl?.find(
      (item) =>
        item?.configModule === "BILLING_REFERRAL" &&
        item?.configKey === "BILL_TO_REFERRAL_DOCTOR",
    );
  }, [userContext?.systemConfigurationColl]);

  const [enableBilling, setEnableBilling] = useState(
    billingConfig?.configValue === "TRUE",
  );

  const handleChangeBillingConfig = async (isEnabled: boolean) => {
    try {
      if ((billingConfig?.systemConfigurationDefaultId ?? 0) > 0) {
        let result: any = "";
        let formData = {
          systemConfigurationId: billingConfig?.systemConfigurationId || 0,
          systemConfigurationDefaultId:
            billingConfig?.systemConfigurationDefaultId || 0,
          consumerId: userContext?.consumerId,
          organizationId: userContext?.organizationId,
          branchId: userContext?.branchId,
          departmentId: null,
          specialityId: null,
          userId: null,
          isDeleted: billingConfig?.isDeleted || false,
          dataManagedBy: userContext?.loginDetail.userId || 0,
          configModule: billingConfig?.configModule || "",
          configValue: isEnabled ? "TRUE" : "FALSE",
          configKey: billingConfig?.configKey || "",
          configDataType: billingConfig?.configDataType || "",
        };

        if ((billingConfig?.systemConfigurationId ?? 0) > 0) {
          result = await UpdateConfiguration(formData);
        } else {
          result = await CreateConfiguration(formData);
        }
        if (result?.data) {
          let configData = result?.data;
          let systemConfigurationColl =
            userContext?.systemConfigurationColl?.map((item) => {
              if (
                item?.configModule === "BILLING_REFERRAL" &&
                item?.configKey === "BILL_TO_REFERRAL_DOCTOR"
              ) {
                if (item?.systemConfigurationId <= 0) {
                  item.systemConfigurationId =
                    configData?.systemConfigurationId || 0;
                }
                item.configValue = isEnabled ? "TRUE" : "FALSE";
              }
              return item;
            });
          updateUserContext({
            ...userContext,
            isAlert: true,
            systemConfigurationColl: systemConfigurationColl,
            alertMessage: result?.message,
            alertType: AlertType.Success,
          });
        }
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: "Something went wrong.",
          alertType: AlertType.Error,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };

  return (
    <Box>
      <Box
        className="main-container"
        sx={{
          width: "100%",
          maxWidth: 900,
          mx: "auto",
        }}
      >
        <Grid xs={12} container className="page-header">
          <Box
            sx={{
              display: "flex",
              height: "100%",
              alignItems: "center",
            }}
          >
            <CustomBreadcrumbs />
          </Box>
        </Grid>
        <Grid gap={2} container>
          <Grid item xs={12} className={"group-container config-settings-panel"}>
            <Typography variant="h6" fontWeight={600} sx={{ padding: "8px" }}>
              Billing Configuration Settings
            </Typography>
            <Box className="config-setting-row">
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: 2,
                  py: 1.5,
                }}
              >
                <Box>
                  <Typography className="config-setting-title">
                    Bill to Referral Doctor
                  </Typography>
                  <Typography className="config-setting-desc">
                    Send the Bill to the Referring Doctor
                  </Typography>
                </Box>
                <Switch
                  checked={enableBilling}
                  onChange={async (e) => {
                    const checked = e.target.checked;
                    setEnableBilling(checked);
                    setIsLoading(true);
                    await handleChangeBillingConfig(checked);
                    setIsLoading(false);
                  }}
                  disabled={isLoading}
                  color="primary"
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default BillingConfiguration;
